var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 22.3958L14.2855 16.6392C17.213 14.199 19.1373 14.4498 21.6653 16.9778L21.6761 16.9886C24.4317 19.7442 26.4061 19.6295 29.1509 17.2269L39.625 8.0625M19.9167 37.625V23.2917M10.9583 37.625V26.875M36.0417 37.625V19.7083M27.9792 37.625V25.0833",
    stroke: "url(#paint0_linear_0_25)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_25",
    x1: 23.5,
    y1: 8.0625,
    x2: 23.5,
    y2: 37.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVision);
export default __webpack_public_path__ + "static/media/ic_vision.18995ed70c8a5532b522be7212ec52cc.svg";
export { ForwardRef as ReactComponent };